export default [
  { id: 'dose', label: 'Dose' },
  { id: 'date', label: 'Date' },
];
